import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VOverlay,{attrs:{"absolute":"","color":"#EBF5FB"}},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":4000,"size":60,"color":_vm.vuetifyColors.primary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }